import { render, staticRenderFns } from "./BinnacleEmails.vue?vue&type=template&id=2b7d3636"
import script from "./BinnacleEmails.vue?vue&type=script&lang=js"
export * from "./BinnacleEmails.vue?vue&type=script&lang=js"
import style0 from "./BinnacleEmails.vue?vue&type=style&index=0&id=2b7d3636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports